// extracted by mini-css-extract-plugin
module.exports = {"search":"Styles_search__3Ni5h"};